// src/components/TermsOfUseModal/content/fr.tsx
import { FC } from 'react';

const FrContent: FC = () => (
  <>
    <h2>CONDITIONS GÉNÉRALES D&apos;UTILISATION ET DE VENTE</h2>
    <h3>Plateforme The Patch</h3>

    <h3>Préambule</h3>
    <p>
      Les présentes Conditions Générales d&apos;Utilisation et de Vente (ci-après les <strong>« CGU/CGV »</strong>) ont pour objet de définir les conditions dans lesquelles la société{' '}
      <strong>The Patch</strong> met à disposition des utilisateurs une plateforme numérique d&apos;aide à la préparation des candidatures et des entretiens d&apos;embauche reposant sur des
      technologies d&apos;intelligence artificielle.
    </p>
    <p>
      Lorsque l&apos;accès à la plateforme est fourni par l&apos;intermédiaire d&apos;un établissement d&apos;enseignement, d&apos;une entreprise ou de toute autre organisation partenaire (ci-après
      une <strong>« Organisation Cliente »</strong>), des conditions spécifiques peuvent s&apos;appliquer en complément ou en substitution des présentes.
    </p>

    <hr />

    <h3>Article 1 – Objet du service</h3>
    <p>The Patch est une plateforme en ligne permettant notamment :</p>
    <ul>
      <li>l&apos;analyse automatisée de CV ;</li>
      <li>l&apos;analyse de lettres de motivation ;</li>
      <li>la génération assistée de cv ;</li>
      <li>la génération assistée de lettres de motivation ;</li>
      <li>la simulation d&apos;entretiens d&apos;embauche personnalisés ;</li>
      <li>la fourniture de feedbacks détaillés post-entretien ;</li>
      <li>la mise en relation avec des offres d&apos;emploi adaptées au profil de l&apos;utilisateur ;</li>
      <li>la candidature directe à certaines offres via la plateforme.</li>
    </ul>
    <p>
      Ces services ont une <strong>finalité pédagogique et d&apos;entraînement</strong> et ne constituent ni un conseil en recrutement, ni une promesse d&apos;embauche.
    </p>

    <hr />

    <h3>Article 2 – Accès au service</h3>
    <p>L&apos;accès à The Patch est réservé aux personnes majeures disposant de la capacité juridique de contracter.</p>
    <p>L&apos;utilisateur s&apos;engage à :</p>
    <ul>
      <li>créer un seul compte personnel ;</li>
      <li>fournir des informations exactes et à jour ;</li>
      <li>conserver la confidentialité de ses identifiants.</li>
    </ul>
    <p>Tout usage frauduleux ou abusif pourra entraîner la suspension ou la suppression du compte.</p>

    <hr />

    <h3>Article 3 – Droit d&apos;utilisation</h3>
    <p>
      The Patch concède à l&apos;utilisateur un droit personnel, non exclusif, non cessible et non transférable d&apos;utiliser la plateforme pour un usage strictement personnel et non commercial.
    </p>
    <p>Toute utilisation à des fins professionnelles, commerciales ou de revente est interdite sans autorisation écrite préalable.</p>

    <hr />

    <h3>Article 4 – Données personnelles et contenus utilisateurs</h3>
    <p>L&apos;utilisateur reconnaît et accepte que l&apos;utilisation de The Patch implique le traitement de données personnelles, notamment :</p>
    <ul>
      <li>données d&apos;identification ;</li>
      <li>CV, lettres de motivation ;</li>
      <li>réponses écrites ou orales aux simulations d&apos;entretien ;</li>
      <li>résultats, scores et historiques d&apos;utilisation.</li>
    </ul>
    <p>
      Les modalités de traitement, de conservation et de suppression de ces données sont précisées dans la <strong>Politique de Confidentialité</strong>.
    </p>
    <p>L&apos;utilisateur conserve la propriété de ses contenus, mais concède à The Patch une licence limitée strictement nécessaire au fonctionnement du service.</p>

    <hr />

    <h3>Article 5 – Tarifs et modalités de paiement</h3>
    <p>L&apos;accès à The Patch peut être :</p>
    <ul>
      <li>gratuit (fonctionnalités limitées) ;</li>
      <li>payant (abonnement).</li>
    </ul>
    <p>Les prix sont indiqués en euros, toutes taxes comprises, et sont exigibles au moment de la souscription.</p>
    <p>Sauf disposition légale contraire, aucun remboursement ne sera effectué en cas d&apos;interruption volontaire de l&apos;utilisation par l&apos;utilisateur.</p>

    <hr />

    <h3>Article 6 – Propriété intellectuelle</h3>
    <p>L&apos;ensemble de la plateforme The Patch, incluant notamment :</p>
    <ul>
      <li>l&apos;architecture logicielle ;</li>
      <li>les algorithmes ;</li>
      <li>les modèles d&apos;analyse ;</li>
      <li>les interfaces ;</li>
      <li>les contenus générés par la plateforme,</li>
    </ul>
    <p>est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de The Patch.</p>
    <p>Toute reproduction, modification ou exploitation non autorisée est strictement interdite.</p>

    <hr />

    <h3>Article 7 – Disponibilité et fonctionnement</h3>
    <p>The Patch s&apos;efforce d&apos;assurer un accès continu à la plateforme, sans pour autant garantir une disponibilité permanente.</p>
    <p>L&apos;utilisateur reconnaît que :</p>
    <ul>
      <li>le service peut comporter des erreurs ou interruptions ;</li>
      <li>The Patch est soumis à une obligation de moyens et non de résultat.</li>
    </ul>

    <hr />

    <h3>Article 8 – Limitation de responsabilité</h3>
    <p>The Patch ne garantit ni l&apos;obtention d&apos;un entretien, ni l&apos;obtention d&apos;un emploi.</p>
    <p>L&apos;utilisateur demeure seul responsable :</p>
    <ul>
      <li>de ses décisions ;</li>
      <li>de l&apos;utilisation des contenus générés ;</li>
      <li>des candidatures effectuées via la plateforme.</li>
    </ul>
    <p>
      La responsabilité totale de The Patch est strictement limitée au montant payé par l&apos;utilisateur au cours des douze (12) derniers mois, dans la limite maximale de{' '}
      <strong>5 000 euros</strong>.
    </p>

    <hr />

    <h3>Article 9 – Résiliation</h3>
    <p>L&apos;utilisateur peut supprimer son compte à tout moment depuis son espace personnel.</p>
    <p>The Patch se réserve le droit de suspendre ou supprimer un compte en cas de :</p>
    <ul>
      <li>violation des présentes CGU/CGV ;</li>
      <li>usage abusif ou frauduleux ;</li>
      <li>atteinte à l&apos;intégrité du service.</li>
    </ul>
    <p>Aucune indemnité ne pourra être réclamée à ce titre.</p>

    <hr />

    <h3>Article 10 – Compatibilité technique</h3>
    <p>The Patch est optimisé pour les navigateurs récents (Chrome, Safari, Firefox).</p>
    <p>Le bon fonctionnement sur d&apos;autres environnements ou versions obsolètes n&apos;est pas garanti.</p>

    <hr />

    <h3>Article 11 – Confidentialité et secret des affaires</h3>
    <p>L&apos;utilisateur s&apos;engage à ne pas :</p>
    <ul>
      <li>reproduire ;</li>
      <li>divulguer ;</li>
      <li>exploiter commercialement</li>
    </ul>
    <p>les éléments, méthodes ou contenus de la plateforme, lesquels sont protégés au titre du secret des affaires.</p>

    <hr />

    <h3>Article 12 – Évolution des services et des conditions</h3>
    <p>The Patch se réserve le droit de faire évoluer :</p>
    <ul>
      <li>les fonctionnalités ;</li>
      <li>les modalités d&apos;accès ;</li>
      <li>les présentes CGU/CGV.</li>
    </ul>
    <p>Toute modification substantielle fera l&apos;objet d&apos;une information préalable.</p>
    <p>L&apos;utilisation continue du service vaut acceptation des nouvelles conditions.</p>

    <hr />

    <h3>Article 13 – Droit applicable et juridiction compétente</h3>
    <p>
      Les présentes CGU/CGV sont soumises au <strong>droit français</strong>.
    </p>
    <p>Tout litige relèvera de la compétence exclusive des tribunaux du ressort du siège social de The Patch, sauf disposition légale impérative contraire.</p>

    <hr />

    <h3>Article 14 – Intégralité</h3>
    <p>Les présentes CGU/CGV constituent l&apos;intégralité de l&apos;accord entre The Patch et l&apos;utilisateur.</p>
    <p>La nullité éventuelle d&apos;une clause n&apos;affectera pas la validité des autres dispositions.</p>
  </>
);

export default FrContent;
